import styled from 'styled-components';
import { rem } from 'polished';

function setFontSize(fontName, fontSizeRem, lineHeight) {
  return `
    font-family: ${fontName};
    font-size: ${fontSizeRem}rem;
    line-height: ${lineHeight}rem;
  `;
}

interface IStyledPostCard {
  vertical: boolean;
  hero: boolean;
}

export const StyledPostCard = styled.div<IStyledPostCard>`
  display: flex;
  overflow: hidden;
  border-radius: ${rem(`8px`)};
  padding: ${({ hero }) => (hero ? 0 : rem(16))};
  background: ${({ theme, hero }) =>
    hero ? `transparant` : theme.colors.blue_1_65};
  transform: scale(1);
  transition: box-shadow 0.8s, transform 0.6s;

  ${({ theme, hero }) =>
    hero
      ? theme.breakpoints.desktop`
          &:hover {
            cursor: pointer;
            .post-card__image .thumbnail__image {
              filter: brightness(1.4) contrast(110%);
              img {
                transform: scale(1.1) rotate(2deg);
              }
            }
          }
  `
      : theme.breakpoints.desktop`
          &:hover {
            cursor: pointer;
            transform: scale(1.05);
            box-shadow: 0px 0px 20px 0px rgba(246, 56, 251, 0.5);
            .post-card__body,
            .post-card__title {
              color: ${theme.colors.white_1};
            }
            .post-card__image .thumbnail__image {
              filter: brightness(1.4) contrast(110%);
              img {
                transform: scale(1.1) rotate(2deg);
              }
            }
          }
  `}

  .post-card {
    display: flex;
    flex-direction: ${({ vertical }) => (vertical ? `column` : `row`)};
  }

  .post-card__caption {
    margin-bottom: 0;
  }

  .post-card__image {
    flex: 1 0 auto;
    height: ${({ hero }) => (hero ? rem(254) : `inherit`)};
    width: 100%;
    ${({ theme }) => theme.breakpoints.phablet`
      flex: 0 1 auto;
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      .thumbnail__image {
        transition: filter 0.6s;
        filter: brightness(0.9) contrast(100%);
        img {
          transition: transform 0.8s;
          transform: scale(1);
        }
      }
    `}
  }
  .post-card__h-divider {
    flex: 1 0 16px;
  }
  .post-card__content {
    flex: 0 1 auto;
    text-align: left;
  }

  .post-card__title {
    display: -webkit-box;
    width: 100%;
    min-height: ${rem(48)};
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-bottom: ${({ hero }) => (hero ? rem(18) : rem(8))};
    transition: color 300ms ease-in-out;
    &--top {
      min-height: ${rem(24)};
      margin-bottom: ${rem(18)};
      ${setFontSize(`Titillium Web`, 1.625, 1.625)}
      ${({ theme }) => theme.breakpoints.phablet`
        ${setFontSize(`Titillium Web`, 3.5, 3.5)}
      `}
    }
  }

  .post-card__body {
    transition: color 300ms ease-in-out;
    p {
      display: -webkit-box;
      width: 100%;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
    }
  }

  .post-card__thumbnail-link {
    display: block;
    flex: 1 0 auto;
    ${({ theme }) => theme.breakpoints.tablet`
      display: flex;
    `}
  }

  .post-card__meta.hero .author {
    margin-top: ${rem(`-6px`)};
    ${({ theme }) => theme.breakpoints.tablet`
      margin-top: 0;
    `}
  }

  .post-card--normal {
  }
`;
